export const INITIALIZE_DATA_SUCCESS = 'INITIALIZE_DATA_SUCCESS';

export const FETCH_ROUTES_REQUEST = 'FETCH_ROUTES_REQUEST';
export const FETCH_ROUTES_SUCCESS = 'FETCH_ROUTES_SUCCESS';
export const FETCH_ROUTES_FAILURE = 'FETCH_ROUTES_FAILURE';
export const CLEAR_ROUTES = 'CLEAR_ROUTES';

export const SELECTED_MFC = 'SELECTED_MFC';
export const SELECTED_ROUTE = 'SELECTED_ROUTE';

export const TOGGLE_LEGEND = 'TOGGLE_LEGEND';

export const FILTER_SERVICES_SET = 'FILTER_SERVICES_SET';
export const RESET_FILTERS_SERVICES = 'RESET_FILTERS_SERVICES';
export const FILTER_SERVICES_SHOW_CHECKED = 'FILTER_SERVICES_SHOW_CHECKED';

export const OPEN_MOBILE_MAP = 'OPEN_MOBILE_MAP';
export const CLOSE_MOBILE_MAP = 'CLOSE_MOBILE_MAP';
export const SET_FILTERS = 'SET_FILTERS';
export const SEARCH_FILTERS = 'SEARCH_FILTERS';
export const CHANGE_FILTER = 'CHANGE_FILTER';
export const RESET_FILTERS = 'RESET_FILTERS';
export const APPLY_FILTERS = 'APPLY_FILTERS';
export const APPLY_SERVICES_FILTERS = 'APPLY_SERVICES_FILTERS';
export const TOGGLE_SHOW_SERVICES = 'TOGGLE_SHOW_SERVICES';
export const TOGGLE_SHOW_OFFICE_SERVICES = 'TOGGLE_SHOW_OFFICE_SERVICES';
export const INITIALIZE_FILTERS = 'INITIALIZE_FILTERS';

export const INITIALIZE_SERVICES_CATALOG = 'INITIALIZE_SERVICES_CATALOG';

export const INITIALIZE_DATA = 'INITIALIZE_DATA';

export const FETCH_CATALOG_FOR_OFFICE_REQUEST =
  'FETCH_CATALOG_FOR_OFFICE_REQUEST';
export const FETCH_CATALOG_FOR_OFFICE_SUCCESS =
  'FETCH_CATALOG_FOR_OFFICE_SUCCESS';
export const FETCH_CATALOG_FOR_OFFICE_ERROR = 'FETCH_CATALOG_FOR_OFFICE_ERROR';

export const SELECT_NEAREST_MFC = 'SELECT_NEAREST_MFC';
